import { displayRequestEducationTable } from "./display-request-education-table";
import { rejectEducationRequest } from "../../infrastructure/repository/request-repository";
import { showSuccessMessage } from "../commons/show-success-message";
import { showErrorMessage } from "../commons/show-error-message";
import { logError, addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";
import { findCompanyId } from "../../infrastructure/repository/company-repository";

export async function rejectEducation(requestId, approved) {
  try {
    const companyId = await findCompanyId();
    await rejectEducationRequest({
      companyId,
      requestId,
      approved,
    });
    displayRequestEducationTable();
    addContextLog("info", "rejectEducationRequest", "request", {
      requestId,
      approved,
    });
    showSuccessMessage(translate("request-section.request-rejected"));
  } catch (e) {
    logError(e, `Error to rejectEducationRequest of ${requestId}`);
    showErrorMessage(translate("common-messages.basic-error-message"), true);
  }
}
